<template>
  <div id="time-periods" class="qb-time-periods">
    <div class="split-button mb10">
      <div class="qb-compare-period left-button">
        <input-select
            v-if="showPeriodType"
            :selectedValue="queryPeriod.type"
            class="qb-results-limit input-ui"
            :options="timePeriodTypeOptions"
            :onChange="(value) => onPeriodTypeChange(value)"
            :allowEmpty="false"
            :preselectFirst="true"
        />
      </div>

      <div class="qb-main-period right-button">
        <div class="form-group">
          <div id="main-date-range" class="form-control date-range-wrapper ">
            <app-date-picker
              ref="tpDatePicker"
              :value="queryPeriod[periodKey]"
              popup-class="qb-period-timepicker"
              inputType="date"
              valueType="YYYY-MM-DD"
              :range="true"
              format="MMM DD YYYY"
              :input-attr="{ name: 'daterange' }"
              :clearable="false"
              range-separator=" - "
              :onCalenderPick="onCustomDatePicked"
              @onInputChange="onDateInputChanged"
              calendarButtonIcon="fas fa-calendar-alt"
            >
              <template slot="sidebar">
                <div class="ranges">
                  <ul>
                    <li v-for="(period, index) in periods_w_custom_range" :key="`${period.type}-${index}-key`"
                        :class="{ active: index === currentPeriodIndex }"
                        @click="onDateRangeChange(period, index)">
                      {{period.label}}
                    </li>
                  </ul>
                  <ul>
                    <li class="customize" @click="showCustomizeForm(!showCustomModal);closeDatePicker()">Customize</li>
                  </ul>
                </div>
              </template>
              <template slot="footer">
                <span class="time-zone-icon"><i class="far fa-globe"></i> {{$t('time_periods.time_zone')}} </span>
              </template>
            </app-date-picker>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPeriodTypeMessage" id="time-period-note" class="mt10 icon-grey" >
      <i class="fas fa-info-circle icon-grey pr5"></i>
      <span :class="queryPeriod.type+'-period'">{{$t('time_periods.'+queryPeriod.type+'_message')}}</span>
    </div>

    <app-form-modal
      :key="`periodsForm-${modalKey}`"
      v-if="showCustomModal"
      id="customize-form"
      :large="true"
      title="time_periods.form.name"
      :fieldsObjects.sync="periodFields"
      @closeModal="closeModal"
      @updateModel="updateCustomPeriodsModel"
      @onSave="saveCustomPeriods"
    />

    <!-- :nameLabel="parentLabel"
        :fields="addEditFields"
        :model="editRecord"
        :showSaveAs="showEditionButtons"
        :showDelete="showEditionButtons"
        @onSave="saveRecord"
        @onDelete="deleteRecord" -->

  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from 'moment'
  import _ from 'lodash'
  import DatePicker from '../date-picker-2';
  import InputSelect from '../form-components/input-select';
  import { VALIDATIONS } from "../../config/const";

  // lazy loading (import()) to avoid eager evaluation of imports for recursive imports
  const FormModal = () => import('../form-modal.vue');

  import { QUERIES } from '../../config/const';

  export default {
    inheritAttrs: false,
    props: {
      queryPeriod: {
        type: Object,
        required: true
      },
      periods: Array,
      // custom_periods: Array,
      period_types: Array,
      periodKey: {
        type: String,
        default: 'range'
      },
      showPeriodType: {
        type: Boolean,
        default: true
      },
      showPeriodTypeMessage: {
        type: Boolean,
        default: true
      }
    },
    components: {
      'app-date-picker': DatePicker,
      'input-select': InputSelect,
      'app-form-modal' : FormModal
    },
    created() {
      this.custom_range.date.from = this.queryPeriod?.[this.periodKey]?.[0];
      this.custom_range.date.to = this.queryPeriod?.[this.periodKey]?.[1];
    },
    computed: {

      timePeriodTypeOptions () {
        const options = [];
        Object.keys(QUERIES.TIME_PERIOD_TYPE).map((key) => {
          options.push({label: this.$t('time_periods.' + QUERIES.TIME_PERIOD_TYPE[key]), value: key.toLowerCase()})
        })
        return options;
      },

      periods_w_custom_range() {
        return [
          ...this.periods,
          ...[this.custom_range]
        ]
      },

      currentPeriod() { return this.periods_w_custom_range.find((period, index) => index === this.currentPeriodIndex) },

      currentPeriodRange() {
        let now = moment();
        let dates = [null, null];
        if(this.currentPeriod.type === 1) {
          dates[0] = now.subtract(this.currentPeriod.date.value, "days").format(this.format);
          dates[1] = moment().format(this.format)
        }
        else if(this.currentPeriod.type === 2) {
          dates[0] = this.currentPeriod.date.from
          dates[1] = this.currentPeriod.date.to
        }
        return dates
      },

      customRangePeriodIndex() { return this.periods_w_custom_range.findIndex(range => range.label === this.$t('time_periods.custom_range')) },

      periodFields() {
        let fieldsObject = {}
        this.newPeriods.forEach((field, index) => {

          // INPUT LABEL
          let inputLabel = {
            type: 'input',
            onBlurOnly: true,
            value: field.label,
            customClass: 'flex',
            name: `label_${index+1}`,
            style: "flex-basis: 25%;",
            label: `Date Range ${index+1}`,
          }
          fieldsObject[`label_${index+1}`] = inputLabel

          // INPUT SELECT: days/range
          let inputType = {
            label: '',
            type: 'select',
            preselectFirst: false,
            value: field.type,
            name: `type_${index+1}`,
            customClass: 'flex',
            style: "flex-basis: 20%;",
            allowEmpty: false,
            optionLabel: "name",
            optionValue: "id",
            options: this.period_types,
            updateKey: true

          }
          fieldsObject[`type_${index+1}`] = inputType
          //INPUT CALENDAR

          let dateInput;

          if (field.type === 1) {
            dateInput = {
              type: 'input',
              label: this.$t('time_periods.form.day'),
              name: `date_${index+1}`,
              hideLabel: true,
              editable: true,
              value: field.date.value,
              customClass: 'flex',
              style: "flex-basis: 50%;",
              inputType: 'number',
              onBlurOnly: true,
              checkOldValue: false,
              validate: [ VALIDATIONS.REQUIRED ],
              step: 1,
              min: 1,
              max: 365
            }
          
          } else {
            const baseDate = new Date();

            const year = baseDate.getFullYear();
            let month = baseDate.getMonth();
            let day = baseDate.getDate();

            month++

            if (day < 10) day = `0${day}`;
            if (!field.date.from) field.date.from = `${year}-${month}-01`;
            if (!field.date.to) field.date.to = `${year}-${month}-${day}`;

            dateInput = {
              type: 'calendar',
              label: this.$t('time_periods.form.period'),
              name: `date_${index+1}`,
              hideLabel: true,
              editable: true,
              clearable: false,
              range: true,
              value: [field.date.from, field.date.to],
              rangeSeparator: " - ",
              customClass: 'flex',
              style: "flex-basis: 50%;",
              format: "MMM DD YYYY",
              valueType :"YYYY-MM-DD",
              validate: [ VALIDATIONS.REQUIRED ]
            }
          }

          fieldsObject[`date_${index+1}`] = dateInput
        })
        return fieldsObject;
      },
       projectId() {
        return this.$route.params.project_id;
      },
      queryId() {
        return this.$route.params.query_id;
      }
     },

    methods: {

      ...mapActions({
        'udpateCustomPeriods': 'queryBuilder/periods/udpateCustomPeriods',
      }),

      onPeriodTypeChange (value) {
        this.$emit('setQueryTimePeriod', { entity: 'type', value: value });
      },
      onDateRangeChange (period, index) {
        let currentPeriodIndex = this.currentPeriodIndex
        this.currentPeriodIndex = index
        const dates = this.resolveDates()
        this.onDateInputChanged(dates);

        //close calendar popup when a range is clicked
        if(currentPeriodIndex == this.currentPeriodIndex) this.closeDatePicker();
      },
      onCustomDatePicked () {
        this.currentPeriodIndex = this.customRangePeriodIndex;
        if(this.presetPeriod !== 'custom_range') {
          this.presetPeriod = 'custom_range';
        }
      },
      onDateInputChanged(dates) {
        this.$emit('setQueryTimePeriod', { entity: [this.periodKey], value: dates });
      },
      showCustomizeForm(state) {
        this.showCustomModal = state
      },
      closeModal() {
        this.newPeriods = this.periods
        this.showCustomModal = false
      },
      closeDatePicker() {
        if(this.$children[0]?.isOpen) this.$children[0].isOpen = false
        if(this.$children[1]?.isOpen) this.$children[1].isOpen = false
      },

      resolveDates() {
        let now = moment();
        let dates = [null, null];

        if(this.currentPeriod.type === 1) {
          dates[0] = now.subtract(this.currentPeriod.date.value, "days").format(this.format);
          dates[1] = moment().format(this.format)
        }
        else if(this.currentPeriod.type === 2) {
          dates[0] = this.currentPeriod.date.from
          dates[1] = this.currentPeriod.date.to
        }
        return dates
      },

      updateCustomPeriodsModel(model, field) {
        // let customPeriods = _.cloneDeep(this.periods)
        let customPeriods = _.cloneDeep(this.newPeriods)
        Object.keys(model).forEach(key => {
          const entry = key.split('_')
          const index = parseInt(entry[1] - 1)
          const type = entry[0]
          let values = model[key]
          if(type === 'date') values = Array.isArray(values) ? { from : values[0], to: values[1]} : { value: values}
          customPeriods[index][type] = values

        })
        this.newPeriods = customPeriods;

        if (field && field.updateKey) this.modalKey++;
      },

      saveCustomPeriods: _.debounce(function (event) {
        this.udpateCustomPeriods({
          projectId: this.projectId,
          queryId: this.queryId,
          periods: this.newPeriods
        }).then((updatedPeriods) => {
          this.showCustomModal = false;
          this.newPeriods = updatedPeriods;
        })
      }, 500)
    },

    data() {
      return {
        format : "YYYY-MM-DD",
        showCustomModal: false,
        QUERIES: QUERIES,
        presetPeriod: this.periods && this.periods[0].type || '',
        currentPeriodIndex: null, 
        custom_range: {id: 5, label: this.$t('time_periods.custom_range'), type: 2, date: { from: null, to: null}},
        modalKey: 0,
        newPeriods: _.cloneDeep(this.periods)
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/components/coding-queries/time-periods";
  .time-zone-icon {
    --bs-text-opacity: 1;
    color: $gray-500 !important;
    font-size: $base-font-size !important;
    margin-bottom: 5px;
    float: left;
  }
</style>